import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../../common/TableHead";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Switch,
  TableHead,
  Autocomplete,
} from "@mui/material";
import { Dispatcher } from "./SiteAboutPageUtils/siteAboutInterfaces";
import FormGroup from "@mui/material/FormGroup";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { useAppStore } from "../../../../appStore";
import { cancelIconRed } from "../../../common/cancelIconRed";
import { checkedCircleIcon } from "../../../common/checkedCircleIcon";

const capitalizeWords = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

const lowerCaseWords = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toLowerCase());
};

export const CameraHealthTabAuopatrolEditMode = ({
  healthCheckData,
  setCameraHealthPatchObject,
  setCameraHealthChangesMade,
  setAddCameraHealthDialogOpen,
  setTurnOffHealthDialogOpen,
}: {
  healthCheckData: any;
  setCameraHealthPatchObject: any;
  setCameraHealthChangesMade: Dispatcher<boolean>;
  setAddCameraHealthDialogOpen: Dispatcher<boolean>;
  setTurnOffHealthDialogOpen: Dispatcher<boolean>;
}) => {
  const titlesArray = ["Camera Health Monitoring On", "Sensitivity"];

  const sensitivityOptions = ["low", "medium", "high"];

  const {
    healthCheckMetricsData,
    setHealthCheckMetricsUpdated,
    setHealthCheckMetricsData,
    healthCheckMetricsUpdated,
  } = useSiteAboutStore();

  const [allMetricsChecked, setAllMetricsChecked] = React.useState(
    healthCheckMetricsData.scene_change_check.enabled &&
      healthCheckMetricsData.stream_quality_check.enabled
  );

  const [currentCheckboxValues, setCurrentCheckboxValues] = React.useState({
    scene_change_check: healthCheckMetricsData.scene_change_check.enabled,
    stream_quality_check: healthCheckMetricsData.stream_quality_check.enabled,
  });

  React.useEffect(() => {
    if (
      currentCheckboxValues.scene_change_check &&
      currentCheckboxValues.stream_quality_check
    ) {
      setAllMetricsChecked(true);
    } else {
      setAllMetricsChecked(false);
    }
  }, [currentCheckboxValues]);

  React.useEffect(() => {
    localStorage.setItem(
      "backupHealthCheckMetricsData",
      JSON.stringify(healthCheckMetricsData)
    );
  }, []);

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{
          postion: "absolute",
          width: "screen",
          fontFamily: "Mulish",
        }}
      >
        {healthCheckData.deployment === 0 ? (
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                Camera Health Monitoring On
              </TableCell>
            </TableRow>
            <TableBody>
              <TableRow>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {cancelIconRed}
                </TableCell>
              </TableRow>
            </TableBody>
          </TableHead>
        ) : (
          <>
            <>
              <TableHeadComponent titlesArray={titlesArray} />
              <TableBody>
                <TableRow>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {healthCheckData.deployment === 3
                      ? checkedCircleIcon
                      : cancelIconRed}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <Autocomplete
                      disablePortal
                      options={sensitivityOptions.map((option: string) => {
                        return capitalizeWords(option);
                      })}
                      defaultValue={capitalizeWords(
                        healthCheckData.sensitivity_level
                      )}
                      onChange={(event: any, newInputValue: any) => {
                        setCameraHealthPatchObject((previousState: any) => {
                          return {
                            ...previousState,
                            sensitivity_level: lowerCaseWords(newInputValue),
                          };
                        });
                        setCameraHealthChangesMade(true);
                      }}
                      sx={{ width: 250 }}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Sensitivity"
                        />
                      )}
                    />
                  </TableCell>
                  {healthCheckData.deployment !== 0 && (
                    <TableCell>
                      <FormGroup>
                        <div className="flex">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={allMetricsChecked}
                                onChange={(event: any) => {
                                  setHealthCheckMetricsUpdated({
                                    connectivity_check: true,
                                    scene_change_check: true,
                                    motion_status_check: true,
                                    recording_check: true,
                                    stream_quality_check: true,
                                    image_quality_check: true,
                                  });
                                  setCurrentCheckboxValues((prevState: any) => {
                                    return {
                                      ...prevState,
                                      scene_change_check: event.target.checked,
                                      motion_status_check: event.target.checked,
                                      recording_check: event.target.checked,
                                      stream_quality_check:
                                        event.target.checked,
                                    };
                                  });
                                  setHealthCheckMetricsData({
                                    ...healthCheckMetricsData,
                                    scene_change_check: {
                                      ...healthCheckMetricsData.scene_change_check,
                                      enabled: event.target.checked,
                                    },
                                    motion_status_check: {
                                      ...healthCheckMetricsData.motion_status_check,
                                      enabled: event.target.checked,
                                    },
                                    recording_check: {
                                      ...healthCheckMetricsData.recording_check,
                                      enabled: event.target.checked,
                                    },
                                    stream_quality_check: {
                                      ...healthCheckMetricsData.stream_quality_check,
                                      enabled: event.target.checked,
                                    },
                                  });
                                }}
                                name="all_metrics"
                              />
                            }
                            label="All Metrics"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                sx={{ marginLeft: "20px" }}
                                checked={
                                  currentCheckboxValues.scene_change_check
                                }
                                onChange={(event: any) => {
                                  const isChecked = event.target.checked;
                                  setCurrentCheckboxValues(
                                    (prevState: any) => ({
                                      ...prevState,
                                      scene_change_check: isChecked,
                                    })
                                  );
                                  setHealthCheckMetricsData({
                                    ...healthCheckMetricsData,
                                    scene_change_check: {
                                      ...healthCheckMetricsData.scene_change_check,
                                      enabled: isChecked,
                                    },
                                  });
                                  setHealthCheckMetricsUpdated({
                                    ...healthCheckMetricsUpdated,
                                    scene_change_check: true,
                                  });
                                }}
                                name="scene_change_check"
                              />
                            }
                            label="Scene Change"
                          />
                          <FormControlLabel
                            sx={{ marginLeft: "20px" }}
                            control={
                              <Checkbox
                                checked={
                                  currentCheckboxValues.stream_quality_check
                                }
                                onChange={(event: any) => {
                                  const isChecked = event.target.checked;
                                  setCurrentCheckboxValues(
                                    (prevState: any) => ({
                                      ...prevState,
                                      stream_quality_check: isChecked,
                                    })
                                  );
                                  setHealthCheckMetricsData({
                                    ...healthCheckMetricsData,
                                    stream_quality_check: {
                                      ...healthCheckMetricsData.stream_quality_check,
                                      enabled: isChecked,
                                    },
                                  });
                                  setHealthCheckMetricsUpdated({
                                    ...healthCheckMetricsUpdated,
                                    stream_quality_check: true,
                                  });
                                }}
                                name="stream_quality_check"
                              />
                            }
                            label="Stream Quality"
                          />
                        </div>
                      </FormGroup>
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </>
          </>
        )}
      </Table>
    </TableContainer>
  );
};
